import React from "react"

const Prose = ({ children }) => (
  <article className="prose prose-neutral prose-h1:text-5xl prose-h2:text-4xl pprose-h3:text-3xl prose-h4:text-2xl prose-lg max-w-none prose-emerald dark:prose-invert dark:prose-hr:border-neutral-600 dark:prose-tr:border-neutral-600">
    {children}
  </article>
)

export default Prose
